import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Pain } from './components/Pain';
import { Method } from './components/Method';
import { Skills } from './components/Skills';
import { ValueStack } from './components/ValueStack';
import { Pricing } from './components/Pricing';
import { Faq } from './components/Faq';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-cream font-sans" data-id="element-0" data-mp="31ctaxf1x1e2u">
      <UrgencyBar data-id="element-1" data-mp="2wj8dpp85co4p" />
      <main data-id="element-2" data-mp="2wip54z4dzc3c">
        <Hero data-id="element-3" data-mp="2whxcnx635uha" />
        <Hook data-id="element-4" data-mp="28ufnm9e7hai0" />
        <Pain data-id="element-5" data-mp="28tw5osok2m3z" />
        <Method data-id="element-6" data-mp="28tmifcuwat1z" />
        <Skills data-id="element-7" data-mp="28t4j27cxrypu" />
        <ValueStack data-id="element-8" data-mp="28sl5t3y8dyi5" />
        <Pricing data-id="element-9" data-mp="23vciyq2516ak" />
        <Faq data-id="element-10" data-mp="23vuo6c6s2uum" />
        <Guarantee data-id="element-11" data-mp="23w4ey1znd61d" />
      </main>
      <Footer data-id="element-12" data-mp="23v2rey1g2r2r" />
    </div>;
}